import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { resolveLegacyRoute } from './legacyRouteRedirects';

interface LegacyRouteRedirectProps {
  children?: ReactNode;
}

export default function LegacyRouteRedirect({ children }: LegacyRouteRedirectProps) {
  const location = useLocation();
  const destination = resolveLegacyRoute(location.pathname, location.search, location.hash);

  if (!destination) {
    return children ?? null;
  }

  const currentLocation = `${location.pathname}${location.search}${location.hash}`;

  // This guard is defensive for future aliases: a malformed map entry must
  // never schedule a self-redirect loop.
  if (destination === currentLocation) {
    return children ?? null;
  }

  return <Navigate to={destination} replace />;
}
